import { useEffect } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import useGlobalRoutesData from "@usas/ui-web/state/security/UseGlobalRoutesData";

const useSAAGroupLanding = () => {
  const navigate = useNavigate();
  const { globalRoutesState, getGlobalRoute } = useGlobalRoutesData();

  useEffect(() => {
    if (globalRoutesState.isArrayLoaded === true) {
      const route = getGlobalRoute('SAA_GROUP_MEMBERS');

      navigate(route?.route);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalRoutesState.isArrayLoaded]);
};

export default useSAAGroupLanding;